import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import React from 'react';
import Box from '../Box';
import useLinkStyles from './useLinkStyles';
export var Link = /*#__PURE__*/React.forwardRef(function Link(_ref, ref) {
  var external = _ref.external,
      disabled = _ref.disabled,
      variant = _ref.variant,
      rest = _objectWithoutPropertiesLoose(_ref, ["external", "disabled", "variant"]);

  var externalProps = external ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {};
  var variantStyles = useLinkStyles({
    variant: variant
  });
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: disabled ? 'span' : 'a',
    ref: ref,
    "aria-disabled": disabled
  }, externalProps, variantStyles, rest));
});
export default Link;